<template>
  <div class="mobile-tp-job-wrapper">
    <div class="list-head" :class="{'head-fixed': isFixed}">
      <div class="filter-left">Jobs for you</div>
      <div class="filter-right" @click.stop="switchFilter">
        <img :src="icons[0].src"/>
        <span>{{state.label}}</span>
      </div>
    </div>
    <list-box class="list-body"
      :display="display"
      :empty="loadedJobsLists.length === 0"
      :loading="loading && loadedJobsLists.length === 0">
      <job-list :loading="loading" :list="loadedJobsLists" @load="load" @fixed="fixed"/>
      <div slot="empty" class="empty">
        <img :src="icons[1].src" alt="empty" />
        <p>Sorry, here is no recommended jobs for you. Please try searching again.</p>
        <el-button class="no-data">
          <a :href="JobBoard">See Job Board</a>
        </el-button>
      </div>
    </list-box>
    <mobile-filter ref="mobileFilter" @filter="filter" :state='state'/>
  </div>
</template>

<script>
import mixin from './index.js'
import JobList from '../share/jobList.vue'
import ListBox from '../share/listBox.vue'
import MobileFilter from '../share/filter.vue'
export default {
  components: {
    MobileFilter,
    JobList,
    ListBox
  },
  mixins: [mixin]
}
</script>

<style lang="scss" scoped>
@font-face {
    font-family: SFProText-Medium;
    src: url(../../../assets/fonts/SF-Pro-Text-Bold.otf);
}

@font-face {
    font-family: SFProText-Semibold;
    src: url(../../../assets/fonts/SF-Pro-Text-Bold.otf);
}

.mobile-tp-job-wrapper {
  background-color: #fff;
  .list-head {
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    padding: 15px;
    width: 100%;

    .filter-left {
      font-size: 16px;
      font-family: SFProText-Bold;
      line-height: 22px;
      font-weight: normal;
      font-weight: bold;
      color: rgb(20, 26, 66);
    }

    .filter-right {
      font-family: SFProText-Semibold;
      font-size: 14px;
      color: #168cd8;
      line-height: 20px;
      position: relative;

      img {
        position: absolute;
        top: 0;
        left: -25px;
      }
    }
  }
  .list-body {
    background-color: rgb(246, 247, 250);
    .empty {
      height: 468px;
      background: #fff;
      text-align: center;
      margin: 48px 0 0;
      img {
        width: 200px;
        height: 150px;
        margin-bottom: 32px;
      }
      p {
        font-size: 28px;
        color: rgba(50, 60, 80, 0.6);
        line-height: 36px;
      }
    }
  }

  .no-data {
    font-size: 20px;
    padding: 10px 20px;
    background: #ffffff;
    border: 1px solid #eee;
    border-radius: 4px;
    align-content: space-between;
    color: #aaa;
    margin-top: 10px;
  }

  .head-fixed {
    position: fixed;
    top: 0;
    opacity: 1;
    z-index: 999;
  }
}
</style>
